import BlogVideoLayoutContainer from "../../../../components/pages/blog/blogDetail/BlogVideoLayout";

const BlogVideoLayout = () => {
  return <BlogVideoLayoutContainer />;
};

export default BlogVideoLayout;
